export default {"src":"/_next/static/media/dall-e.a621d4c5.svg","height":512,"width":512};